import styled from 'styled-components';

export const WeavePanelWrapper = styled.div`
  white-space: normal;
  margin-bottom: 24px;
`;
